/** Reshet's GAM network */
export const AD_NETWORK = '/36476105'

/** 13 Shorts: own units, per platform (the Shorts ad spec) */
export const SHORTS_AD_UNITS = {
  desktop: 'Shorts/shorts_desktop',
  mobileWeb: 'Shorts/shorts_mw',
} as const
